/**
 * Monthly payouts are held to maturity: a position on monthly payouts, on a deal whose own
 * schedule is not monthly, cannot buy or sell on the secondary market. The backend refuses those
 * trades; this lets the app say so before an order is placed.
 */
export const HELD_TO_MATURITY_NOTE =
  "Your position in this deal is on monthly payouts, which are held to maturity. It can't be sold or added to on the secondary market.";

const isMonthly = (value) => String(value || "").toLowerCase() === "monthly";

/**
 * Whether a GET token/{symbol}/balance response is for a position held to maturity.
 * Reads the backend's held_to_maturity; before it sends one, the same rule from the
 * election the response already carries.
 */
export function isHeldToMaturity(balance) {
  if (!balance || typeof balance !== "object") return false;
  if (typeof balance.held_to_maturity === "boolean") return balance.held_to_maturity;
  return isMonthly(balance.payout_election) && !isMonthly(balance.deal_payout_frequency);
}
